import styled from 'styled-components'
import {
  COLOR,
  FONT_SIZE,
  BUTTON_SIZE,
  Z_INDEXS,
} from '../../../themes'
import { colorThemeSelector } from '../../../helpers';

const padding = 70

export const StyleModal = styled.div`
  .div-Modal{
    background: #000000;
    border: 1px solid ${COLOR.GRAY_10};
    display: block;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left:0;
    opacity: 0.7;
    z-index: ${Z_INDEXS.LV_5};
  }
  .btn-modal {
    bottom: 0;
    margin-bottom: auto;
    margin-top: 11px
  }
  .tabel {
    color: ${COLOR.BLACK_1};
    display: table;
    border-collapse: collapse;
    width: 100%;
    background: ${COLOR.WHITE}
  }

  .table-row{
    display: table-row;
    font-size: ${FONT_SIZE.TN};
  }

  .table-cell, .table-cell-default{
    display: table-cell;
    vertical-align: middle;
  }

  .table-row-border-header{
    display: table-row;
    font-size: ${FONT_SIZE.MN};
    border-bottom: 1px solid ${COLOR.GRAY_5};
  }

  .table-row-border{
    display: table-row;
    font-size: ${FONT_SIZE.MN};
    border-bottom: 1px solid ${COLOR.GRAY_5};
  }

  .table-row-block{
    width: 10px;
    height: 70px;
    background: ${COLOR.BLUE_1};
    float: left;
    display: none;
  }
  
  .table-row-border:hover {
    -webkit-box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    -moz-box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    box-shadow: 0px 4px 6px 1px ${COLOR.GOLD_1};
    .table-row-block {
      display: block;
    }
    .first{
      padding-left: 16px;
    }
  }

  .table-cell{
    line-height: 70px;
  }


  .sub-content {
    padding: 60px;
  }
  .content-Modal{
    border-radius: 8px;
    z-index: ${Z_INDEXS.LV_5};
    color: ${COLOR.BLACK_1};
    display: block;
    position: fixed;
    background: #FFF;
    top: 55px;
    height: 760px;
    width: 1300px;
    font-size: ${FONT_SIZE.SM};
    padding: 10px;
    text-align: center;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    -webkit-animation-name: example; /* Safari 4.0 - 8.0 */
    -webkit-animation-duration: 0.5s; /* Safari 4.0 - 8.0 */
    animation-name: example;
    animation-duration: 0.5s;
  }

  .container-iframe {
    position: relative;
    overflow: hidden;
    padding-bottom: 42%
  }

  .responsive-iframe {
    display: block;
    overflow: hidden;
    border: 0;
    align-self: center;
    position: absolute;
    top:0;
    left:0;
    width: 100%;
    height: 100%;
  }


  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  /* Standard syntax */
  @keyframes example {
    0%   {
      padding-left: 30px;
      padding-right: 30px;
    }
    100%  {
      padding-left: ${padding}px;
      padding-right: ${padding}px;
    }
  }

  .head-modal{
    font-family: NunitoRegular;
    font-size: ${FONT_SIZE.XL};
    font-weight: bold;
    letter-spacing: 1px;
  }

  .description{
    font-family: NunitoRegular;
    margin-top: 30px;
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }

  .input-delete{
    margin-top: 50px;
    border: none;
    width: 100%;
    outline: none;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    padding-bottom: 6px;
    ::placeholder {
      font-size: ${FONT_SIZE.XS};
      color: ${COLOR.GRAY_3}

    }
  }

  .modal-btn-confirm, .modal-btn-keep{
    width: 196px;
    margin-top: 40px;
    font-size: ${FONT_SIZE.XXS};
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    border: 1px solid ${COLOR.GRAY_6};
    background: ${COLOR.WHITE};
    float: none;
    color: ${COLOR.BLACK_1};
    margin: 26px;
    font-family: NunitoBold
  }

  .modal-btn-confirm {
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    margin-left: 10px;
    color: ${({ colorTheme }) => colorThemeSelector(colorTheme).FONT_COLOR.TEXT ?? COLOR.BLACK_1};
  }

  .is-pass{
    border: 1px solid ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    background-color: ${({ colorTheme }) => colorTheme || COLOR.GOLD_1};
    cursor: pointer;
  }

  .text-error{
    margin-top: 10px;
    font-size: ${FONT_SIZE.TN};
    color: ${COLOR.GOLD_1};
  }

  .text-data{
    margin-top: 50px;
    border-bottom: 1px solid ${COLOR.BLACK_1};
    font-size: ${FONT_SIZE.XS};
    color: ${COLOR.BLACK_1};
  }
`;
